import { NodeSpec, NodeType } from "prosemirror-model";
import {
	Command,
	EditorState,
	Transaction
} from "prosemirror-state";

export function setNodeAttributes<TAttributes extends { [key: string]: any; }>(
	setAttributes: (existingAttributes: { [key: string]: any; }) => TAttributes,
	doesNodeHaveSupport: (nodeSpec: NodeSpec) => boolean,
	isAlreadySet: (arbitraryAttrs: { [key: string]: any; }) => boolean
): Command {
  return (
		state: EditorState,
		dispatch: ((tr: Transaction) => void) | undefined
	) => {
		const { from, to } = state.selection;
		let nodeTypeAndExistingAttributes: NodeTypeAndAttributes | null = null;

		state.doc.nodesBetween(
			from,
			to,
			(node): boolean | undefined => {
				if (nodeTypeAndExistingAttributes) {
					return false;
				}

				if (!doesNodeHaveSupport(node.type.spec)) {
					return undefined;
				}

				if (!node.isTextblock || isAlreadySet(node.attrs)) {
					return undefined;
				}

				nodeTypeAndExistingAttributes = {
					nodeType: node.type,
					attributes: node.attrs
				};

				return undefined;
			}
		);

		if (!nodeTypeAndExistingAttributes) {
			return false;
		}

		const {
			nodeType,
			attributes: existingAttributes
		} = nodeTypeAndExistingAttributes as NodeTypeAndAttributes;

		if (dispatch) {
			const { tr } = state;

			tr.setBlockType(
				from,
				to,
				nodeType,
				setAttributes(existingAttributes)
			);
			tr.scrollIntoView();
			dispatch(tr);

		}
		return true;
	};
}

type NodeTypeAndAttributes = {
	nodeType: NodeType;
	attributes: { [key: string]: any; };
};